import {  NgModule } from '@angular/core';

import { MainsalesResourcesResolver } from '../resolvers/mainsales-resources.resolver';
import { ViewResourcesResolver } from '../resolvers/viewResources.resolver';
import { ImagesResolver } from '../resolvers/images.resolver';

@NgModule({
    providers: [
        MainsalesResourcesResolver,
        ViewResourcesResolver,
        ImagesResolver
    ],
   
})
export class ResolversModule { }

